import React from 'react';
import { useEstimateSession } from './hooks/useEstimateSession';
import VersionSelection from './views/VersionSelection';
import QuestionnaireFlow from './views/QuestionnaireFlow';
// import InquiryForm from './views/InquiryForm';
import EstimateResult from './views/EstimateResult';
import './styles/layout.css';
import './styles/steps.css';
import './styles/result-screen.css';
import './styles/estimate-document.css';


const AutoEstimateWidget = () => {
    const {
        loading,
        error,
        currentQuestion,
        currentAnswer,
        totalQuestions,
        isCompleted,
        isSubmitted,
        result,
        submitAnswer,
        availableVersions,
        activeVersion,
        selectVersion,
        goBack,
        resetSession, // Used for Reselect
        restartCurrentSession, // Used for Restart
        submitInquiry
    } = useEstimateSession();

    // Reset local state when session resets
    const handleReset = async () => {
        await resetSession();
    };

    if (loading) return <div className="ae-loading">견적 시스템 로딩중...</div>;

    if (error) {
        return (
            <div className="ae-error">
                <p>오류가 발생했습니다.</p>
                <button onClick={handleReset}>처음부터 다시 시작하기</button>
            </div>
        );
    }

    // 1. Version Selection
    if (availableVersions?.length > 0 && !currentQuestion && !isCompleted) {
        return <VersionSelection versions={availableVersions} onSelect={selectVersion} />;
    }

    // 1.5 Empty State
    if (availableVersions?.length === 0 && !currentQuestion && !isCompleted) {
        return (
            <div className="ae-container">
                <div style={{ textAlign: 'center', padding: '80px 20px', color: '#666', background: '#fff', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                    <h2 style={{ color: '#333', marginBottom: '15px' }}>현재 준비된 예상 견적이 없습니다.</h2>
                    <p>관리자가 곧 새로운 견적 폼을 등록할 예정입니다. 나중에 다시 확인해주세요.</p>
                </div>
            </div>
        );
    }

    // 2. Questionnaire Flow
    if (currentQuestion && !isCompleted) {
        return (
            <QuestionnaireFlow
                currentQuestion={currentQuestion}
                initialAnswer={currentAnswer}
                totalQuestions={totalQuestions}
                activeVersion={activeVersion}
                onAnswer={submitAnswer}
                onBack={goBack}
                onReselect={resetSession}
                onRestart={restartCurrentSession}
            />
        );
    }

    // 3. Result (Final) - Gated View handles the inquiry now
    if (isCompleted) {
        return <EstimateResult
            result={result}
            isSubmitted={isSubmitted}
            onRestart={restartCurrentSession}
            onReselect={resetSession}
            onSubmitInquiry={submitInquiry}
        />;
    }

    // Fallback?
    return <div className="ae-loading">초기화 중...</div>;
};

export default AutoEstimateWidget;
